<p-dialog [(visible)]="displayCheckout" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw', height: '80vh' }" [closable]="false">
	<ng-template pTemplate="header">
		<fa-icon [icon]="[checkoutHeaderIconPrefix, checkoutHeaderIcon]" class="me-4" size="3x"></fa-icon>
		<div class="d-flex display-3">{{ checkoutHeader }}</div>
		<div class="display-3 ms-auto">{{ kioskService.activeOrder.value.total | currency }}</div>
	</ng-template>

	<app-kiosk-order-type-select
		*ngIf="currentCheckoutStep === 'orderTypeSelect'"
		(orderTypeSelectedChange)="selectOrderType($event)"
	></app-kiosk-order-type-select>
	<app-kiosk-promo-code-select
		*ngIf="currentCheckoutStep === 'promoCodeSelect'"
		(promoCodeCompleteChange)="checkoutFooterButtonDisabled = false"
	></app-kiosk-promo-code-select>
	<app-kiosk-order-identifier
		*ngIf="currentCheckoutStep === 'identifierInput'"
		(orderIdentifierChange)="checkoutFooterButtonDisabled = false"
	></app-kiosk-order-identifier>
	<app-kiosk-payment-request *ngIf="currentCheckoutStep === 'paymentRequest'"></app-kiosk-payment-request>
	<app-kiosk-submit-order *ngIf="currentCheckoutStep === 'paymentComplete'"></app-kiosk-submit-order>

	<ng-template pTemplate="footer">
		<div class="d-flex" style="height: 10vh">
			<div
				pRipple
				*ngIf="checkoutFooterBackDisplay"
				class="flex-fill p-button p-button-danger p-button-raised w-100 h-100 me-2"
				(click)="displayCheckoutChange.emit(false)"
			>
				<div class="d-flex mx-auto display-6">
					<fa-icon [icon]="['far', 'times-circle']" size="lg" class="ms-1 me-2"></fa-icon>
					Cancel
				</div>
			</div>
			<div
				pRipple
				class="flex-fill p-button p-button-raised w-100 h-100 ms-2"
				[ngClass]="checkoutFooterButtonDisabled ? 'p-button-secondary' : 'p-button-success'"
				(click)="checkoutFooterButtonDisabled ? undefined : checkoutAdvanceStep()"
			>
				<div class="d-flex mx-auto display-6">
					<fa-icon [icon]="[checkoutFooterIconPrefix, checkoutFooterIcon]" size="lg" class="ms-1 me-2"></fa-icon>
					{{ checkoutFooter }}
				</div>
			</div>
		</div>
	</ng-template>
</p-dialog>
